<template>
  <div class="home">
    <el-card shadow="never" class="w1200">
      <el-row>
        <el-col :span="12">
          <!-- ADD BY LANXINYU ============================================================ -->
          <el-row class="video-top" v-if="special == 'MTA0'">
            <el-col :span="4">
              <p :class="videoIndex == 0 ? 'on' : ''" @click="videoTab(0)">
                帮助视频
              </p>
            </el-col>
          </el-row>
          <!-- ============================================================================= -->
          <el-row v-else class="video-top">
            <el-col :span="4">
              <p :class="videoIndex == 0 ? 'on' : ''" @click="videoTab(0)">
                项目简介视频
              </p>
            </el-col>
            <el-col :span="4">
              <p :class="videoIndex == 1 ? 'on' : ''" @click="videoTab(1)">
                项目引导视频
              </p>
            </el-col>
          </el-row>
          <div class="video-box">
            <video
              :src="videos.video[videoIndex]"
              :poster="videos.videoImg[videoIndex]"
              controls="controls"
              width="580"
            ></video>
          </div>
        </el-col>
        <el-col :span="12" class="right-box">
          <div class="intro" v-html="desc">
            <!-- <span ></span> -->
            <!-- {{ desc }} -->
          </div>
          <p class="tips">
            推荐使用Chrome、Firefox、Safari浏览器，360浏览器请使用极速模式。
          </p>
          <el-row type="flex" justify="left">
            <el-button type="primary" @click="handleClickExam"
              >在线测试</el-button
            >
            <el-button type="primary" @click="handleClickReport"
              >实验报告</el-button
            >
            <el-button type="primary" @click="manual">操作手册</el-button>
            <el-button type="primary" @click="startExp">开始实验</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <br class="hidden" />
    <el-card shadow="never" class="w1200 hidden">
      <Title :title="['服务团队', 'Service Team']" />
      <el-carousel
        indicator-position="outside"
        arrow="nerver"
        class="teacher-list"
      >
        <el-carousel-item v-for="i in Math.ceil(infoList.length / 5)" :key="i">
          <el-row type="flex" justify="space-between">
            <el-col
              :span="parseInt(24 / infoNum(i))"
              v-for="j in infoNum(i)"
              :key="j"
              class="teacher-info"
            >
              <el-card>
                <el-avatar
                  :size="100"
                  :src="infoList[(i - 1) * 5 + j - 1].image"
                ></el-avatar>
                <p>{{ infoList[(i - 1) * 5 + j - 1].name }}</p>
                <p class="title">{{ infoList[(i - 1) * 5 + j - 1].title }}</p>
                <p class="desc">{{ infoList[(i - 1) * 5 + j - 1].desc }}</p>
              </el-card>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-card>
    <br class="hidden" />
    <el-card shadow="never" class="w1200 hidden">
      <Title :title="['实验教学项目', 'Service Team']" />
      <el-row>
        <el-col :span="6">
          <el-card class="image">
            <el-avatar
              :size="100"
              :src="require('@/assets/image/b.png')"
            ></el-avatar>
            <p>实验报告</p>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-image
            class="image"
            :src="require('@/assets/image/b.png')"
          ></el-image>
        </el-col>
        <el-col :span="6">
          <el-image
            class="image"
            :src="require('@/assets/image/c.png')"
          ></el-image>
        </el-col>
        <el-col :span="6">
          <el-image
            class="image"
            :src="require('@/assets/image/d.png')"
          ></el-image>
        </el-col>
      </el-row>
    </el-card>
    <br />
    <el-card shadow="never" class="w1200">
      <Title :title="['共享情况', 'Shareing Plan']" />
      <el-row :gutter="25">
        <el-col :span="16">
          <div id="charts" class="charts"></div>
        </el-col>
        <el-col :span="8" class="count">
          <div>
            <h4>总浏览量</h4>
            <h2>{{ count.browse }}</h2>
            <img :src="require('@/assets/image/count_bg.png')" />
          </div>
          <div>
            <h4>交互步骤通关量</h4>
            <h2>{{ count.complete }}</h2>
            <img :src="require('@/assets/image/count_bg.png')" />
          </div>
        </el-col>
      </el-row>
    </el-card>
    <br />
    <el-card shadow="never" class="w1200">
      <Title :title="['反馈信息', 'Feedback']" />
      <div v-for="item in spit.list" :key="item.id">
        <el-row class="spit">
          <el-col :span="2">
            <el-avatar :size="60" :src="item.wx_img"></el-avatar>
          </el-col>
          <el-col :span="22" class="info">
            <p>{{ item.nickname }}</p>
            <el-row>
              <el-col :span="16">
                <p class="content">{{ item.phonetype }}</p>
              </el-col>
              <el-col :span="8" class="date">
                <p class="content">{{ item.subtime }}</p>
              </el-col>
            </el-row>
            <p class="content">{{ item.spit }}</p>
            <el-image
              v-if="item.pic"
              :src="item.pic"
              :preview-src-list="[item.pic]"
              class="spit-image"
            ></el-image>
            <div v-if="item.huifu[0]">
              <hr />
              <p class="content" v-html="item.huifu[0].content"></p>
              <p class="bottom">官方回复 {{ item.huifu[0].subtime }}</p>
            </div>
          </el-col>
        </el-row>
        <hr />
      </div>
      <el-pagination
        layout="prev, pager, next"
        :page-size="spit.size"
        :total="spit.total"
        @current-change="getSpitInfo"
      >
      </el-pagination>
    </el-card>
    <br />
    <el-card shadow="never" class="w1200" v-if="special != 'MTU5MTMx'">
      <Title :title="['手机APP及电脑版软件下载区', 'Software Download Area']" />
      <!-- <el-row>
        <el-col :span="8">
          <el-image
            v-if="android_img"
            class="download-image"
            :src="android_img"
          ></el-image>
          <el-image
            v-else
            class="download-image"
            :src="require('@/assets/image/android.png')"
          ></el-image>
        </el-col>
        <el-col :span="8">
          <el-image
            class="download-image"
            src="https://www.mools.net/lims/web/down/chemlab/iponeewm.png"
          ></el-image>
        </el-col>
        <el-col :span="8">
          <el-image
            class="download-image"
            style="cursor: pointer;"
            src="https://www.mools.net/lims/web/DeclarationWebsite/img/windown.jpg"
            @click="handleClickWindow"
          ></el-image>
        </el-col>
      </el-row> -->
      <div class="downloadList" style="cursor:pointer;">
        <el-image
          v-for="item in downloadList"
          :key="item.id"
          :src="item.url"
          @click="showDownLoad(item.link)"
        ></el-image>
      </div>
    </el-card>
  </div>
</template>

<script>
import Title from "@/components/Title";

import {
  getVirtualSimulationInfo,
  getExpInfoWebApp,
  getExpInfoByExpidEcWebApp,
  getExpCountWebapp,
  getSpitPageCountWebApp,
  getSpitListWebApp,
  getInfoList,
  getDesc
} from "@/api/views/home";

import { Message } from "element-ui"; //项目已经全局引入element的话可以不单独引入

export default {
  name: "Home",
  components: {
    Title
  },
  data() {
    return {
      downloadList: [
        {
          id: 1,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-40-25_6113314.png",
          link: "https://appgallery.huawei.com/app/C102330335"
        },
        {
          id: 2,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-40-56_1559023.png",
          link: "https://sj.qq.com/appdetail/com.mools.mlabs"
        },
        {
          id: 3,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-41-14_7132445.png",
          link: "https://apps.apple.com/cn/app/mlabs-pro/id1550912725"
        },
        {
          id: 4,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-41-29_6193006.png",
          link: "https://apps.apple.com/cn/app/mlabs-pro/id1550912725"
        },
        {
          id: 6,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-41-56_8474559.png",
          link: "https://www.microsoft.com/store/apps/9NFS568R1Z31"
        },
        {
          id: 5,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-41-43_9477993.png",
          link: ""
        },
        {
          id: 7,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-42-16_5322026.png",
          link: ""
        },
        {
          id: 8,
          url:
            "https://moolsvideo.oss-cn-beijing.aliyuncs.com/baiduOCR/2023-02-16-13-42-35_3650764.png",
          link: ""
        }
      ],
      header: "首页",
      desc: null,
      expId: "",
      // webgl地址
      expUrl: "",
      projectId: "",
      // 素材地址
      manualUrl: "",
      videoIndex: 0,
      videos: {
        video: [],
        videoImg: []
      },
      infoList: [],
      count: {
        browse: 0,
        complete: 0
      },
      countList: {
        date: [],
        browse: [],
        complete: []
      },
      spit: {
        page: 1,
        size: 2,
        total: 0,
        list: []
      },
      // 是否是西安电子科技大学专门定做的页面（url的School_id参数为'MTA0'时）
      special: this.$route.query.School_id,
      // PC软件下载链接
      pc_download: "",
      // 安卓二维码图片
      android_img: ""
    };
  },
  mounted() {
    getVirtualSimulationInfo(this.$route.query.School_id || "MTUw").then(
      res => {
        console.log(res.data[0].android_img);
        this.pc_download = res.data[0].pc_download;
        this.android_img = res.data[0].android_img;
        this.expId = res.data[0].exp_id;
        this.projectId = res.data[0].project_id;

        this.videos = {
          video: [res.data[0].introVideo, res.data[0].guideVideo],
          videoImg: [res.data[0].introVideoImg, res.data[0].guideVideoImg]
        };

        this.expUrl = res.data[0].webgl_url;

        getExpInfoWebApp(this.expId).then(res => {
          this.manualUrl = res.data.helpurl;
        });

        getExpInfoByExpidEcWebApp(this.expId).then(res => {
          this.countList.date = res.data.time;
          this.countList.browse = res.data.liulan;
          this.countList.complete = res.data.tongguan;
          this.drawLines();
        });
        getExpCountWebapp(this.expId).then(res => {
          this.count.browse = res.data.expcidtimeCount;
          this.count.complete = res.data.expdataCount;
        });
        // 获取分页页码
        getSpitPageCountWebApp(this.expId, this.spit.size).then(res => {
          this.spit.total = res.data.count;
        });
        this.getSpitInfo(this.spit.page);
      }
    );
    getDesc(this.$route.query.School_id).then(res => {
      if (res.data) {
        this.desc = res.data.desc;
      }
    });
    this.drawLines();
  },
  created() {
    this.$cookie.set("params", JSON.stringify(this.$route.query), 1);
    getInfoList().then(res => {
      this.infoList = res.data;
    });
  },
  methods: {
    showDownLoad(link) {
      if (!link) {
        Message.warning("请前往应用商店下载！");
      }
      link ? window.open(link) : "";
    },
    handleClickExam() {
      if (this.$store.state.userInfo == "") {
        this.$store.commit("setLoginDialog", true);
      } else {
        window.open(
          "https://www.mools.net/lims/web/answer/select.html?id=" +
            this.projectId
        );
      }
    },
    handleClickReport() {
      if (this.$store.state.userInfo == "") {
        this.$store.commit("setLoginDialog", true);
      } else {
        window.open(
          "https://www.mools.net/lims/web/Final_exam/report_fill.html?id=" +
            this.projectId +
            "&sign=pdf"
        );
      }
    },
    videoTab(i) {
      if (this.videoIndex != i) {
        this.videoIndex = i;
      }
    },
    infoNum(i) {
      return this.infoList.length - i * 5 > 0 ? 5 : this.infoList.length % 5;
    },
    drawLines() {
      let charts = this.$echarts.init(document.getElementById("charts"));

      charts.setOption({
        grid: {
          top: "50px",
          left: "50px",
          right: "15px",
          bottom: "50px"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["总浏览量", "交互步骤通关量"]
        },
        xAxis: {
          type: "category",
          data: this.countList.date.reverse()
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "总浏览量",
            type: "line",
            stack: "总浏览量",
            itemStyle: {
              normal: {
                color: "#eca59c",
                lineStyle: {
                  color: "#eca59c"
                }
              }
            },
            data: this.countList.browse,
            smooth: true
          },
          {
            name: "交互步骤通关量",
            type: "line",
            stack: "交互步骤通关量",
            itemStyle: {
              normal: {
                color: "#159cf6",
                lineStyle: {
                  color: "#159cf6"
                }
              }
            },
            data: this.countList.complete,
            smooth: true
          }
        ]
      });
    },
    manual() {
      window.open(this.manualUrl, "_blank");
    },
    startExp() {
      window.open(this.expUrl, "_blank");
    },
    /**
     * @name: PC版软件下载链接
     * @author: camellia
     * @date: 2022-06-09
     */
    handleClickWindow() {
      /*window.open(
        "https://moolsnetapk.oss-cn-beijing.aliyuncs.com/online/MLabs_PC.rar",
        "_blank"
      );//*/
      window.open(this.pc_download, "_blank");
    },
    getSpitInfo(page) {
      getSpitListWebApp(this.expId, page, this.spit.size).then(res => {
        this.spit.list = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.downloadList {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  column-gap: 30px;
}
.video-top {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(#97989a 40px, transparent 0);
  padding: 0;
  height: 45px;
  line-height: 45px;
  width: 580px;
  z-index: 10;

  .el-col {
    max-width: 90px;
  }

  p {
    margin: 0;
    position: relative;
    font-size: 13px;
    cursor: pointer;
  }

  .on {
    background: url("../assets/image/message.png") no-repeat;
  }
}

.video-box {
  height: 320px;
  background-color: #484b4b;
  position: relative;
  top: 40px;
}

.right-box {
  padding: 0 20px 0 30px;
  min-height: 235px;

  .intro {
    text-align: left;
    min-height: 255px;
    max-width: 570px;
    font-size: 15px;
    line-height: 25px;
    text-indent: 30px;
    text-align: justify;
  }

  .tips {
    font-size: 15px;
    font-weight: 600;
  }

  .el-button {
    border-radius: 0;
  }

  button {
    display: inline-block;
    width: 130px;
    margin-right: 20px;
    background-color: #477dbf;
    border-color: #477dbf;
  }
}

.teacher-list {
  position: relative;
  top: -10px;
  padding-top: 10px;

  /deep/ .el-carousel__container {
    height: 350px;
  }

  /deep/ .el-carousel__indicator button {
    background-color: #c0c4cc;
    opacity: 0.24;
  }
  /deep/ .el-carousel__indicator button {
    background: grey;
  }
  /deep/ .el-carousel__indicator.is-active button {
    background-color: #477dbf;
  }

  .el-row {
    padding-top: 10px;
  }

  .teacher-info .el-card {
    z-index: 100;
    width: 185px;
    height: 330px;
    margin: 0 auto;

    &:hover {
      transform: translateY(-10px);
    }

    .title {
      font-size: 14px;
      color: grey;
    }

    .desc {
      font-size: 15px;
      color: #5f6363;
      text-align: left;
    }
  }
}

.charts {
  width: 100%;
  height: 450px;
  background-color: #fafafa;
  border: 1px solid #e4e4e4;
}

.count {
  div:first-child {
    margin-bottom: 20px;
  }

  div {
    min-height: 200px;
    padding: 7px 0;
    background-color: #fafafa;
    border: 1px solid #e4e4e4;
  }
}

.download-image {
  height: 160px;
  width: 160px;
  padding: 5px;
  border: 1px solid #ddd;
  box-shadow: 1px 2px 5px -3px #6f6f6f;
}

.image {
  height: 160px;
  width: 160px;
  padding: 5px;
  border: 1px solid #ddd;
  box-shadow: 1px 2px 5px -3px #6f6f6f;
}

.spit {
  .info {
    text-align: left;
  }

  .date {
    text-align: right;
  }

  .content {
    color: #999;
  }

  /deep/ .spit-image {
    margin: 10px 0;

    img {
      height: 160px;
      width: auto;
    }

    /* 大图预览 */
    .el-image-viewer__img {
      height: auto;
      width: 60%;
    }
  }

  hr {
    margin: 20px 0 10px 0;
  }

  .bottom {
    color: #e5e5e5;
  }

  p {
    font-size: 14px;
    margin: 0 0 4px 0;
  }
}

hr {
  height: 1px;
  border: 0;
  background-color: #e5e5e5;
}
</style>
